import React from 'react'
import _ from 'lodash'
import { COURSE_TYPE } from 'src/constants/eLearning'
import { openDialog } from 'src/redux/slices/alertDialog'
import {
  setChangeCamera,
  openDialog as openDetailDialog,
} from 'src/redux/slices/eLearning/detail'
import { handleRelationObj } from 'src/redux/slices/eLearning/learning/events'
import { startLoading, stopLoading } from 'src/redux/slices/loading'
import { postEnrollCourse } from 'src/services/eLearning/enroll'
import {
  postCourseLogLearner,
  postCourseLogLearnerPerLesson,
} from 'src/services/eLearning/learning'
import { getDetailState } from '../events'
import IdNoDialog from './IdNoDialog'
import { USER_TYPE } from '../../GeneralEnroll/constant'
import ArrowForward from '@mui/icons-material/ArrowForward'

export const handleEnrollment = (uuid) => async (dispatch) => {
  const data = getDetailState().data
  const courseType = _.get(data, 'courseType', '')
  const user = JSON.parse(localStorage.getItem('user'))

  if (courseType === COURSE_TYPE.OIC) {
    const path = `/e-learning/course/enroll/${uuid}`
    if (!user?.hasIdCardNo && user?.userType !== USER_TYPE.PROSPECT) {
      dispatch(
        openDialog({
          content: <IdNoDialog path={path} />,
          type: 'content',
        })
      )
    } else {
      window.location.href = path
    }
  } else {
    if (user?.userType === USER_TYPE.PROSPECT) {
      const path = `/e-learning/course/general-enroll/${uuid}`
      window.location.href = path
    } else {
      dispatch(
        openDialog({
          title: 'ยืนยันการลงทะเบียน',
          message: ['คุณต้องการลงทะเบียนหลักสูตรนี้?'],
          buttonRight: {
            label: 'ยืนยัน',
            handleClick: () => dispatch(handleSubmitEnrollGeneral()),
          },
          buttonLeft: { label: 'ยกเลิก' },
        })
      )
    }
  }
}

export const handleSubmitEnrollGeneral = () => async (dispatch) => {
  const eLearningCourse = handleRelationObj(getDetailState().data)
  dispatch(startLoading())
  const response = await dispatch(postEnrollCourse({ eLearningCourse }))
  const user = JSON.parse(localStorage.getItem('user'))

  if (_.isEmpty(response.error)) {
    const eLearningCourseBatchLearner = handleRelationObj(response.payload.data)
    // create log after enroll by default value
    const resLog = await dispatch(
      postCourseLogLearnerPerLesson({ eLearningCourseBatchLearner })
    )
    dispatch(stopLoading())

    if (_.isEmpty(resLog?.error) && user?.userType === USER_TYPE.PROSPECT) {
      dispatch(handleOpenSuccessDialog(eLearningCourse.uuid))
    } else if (_.isEmpty(resLog?.error)) {
      dispatch(handleSuccess())
    }
  } else dispatch(stopLoading())
}

export const handleSuccess = () => (dispatch) => {
  dispatch(
    openDialog({
      iconType: 'success',
      title: 'ลงทะเบียนเข้าอบรมสำเร็จ',
      buttonRight: {
        handleClick: () => window.location.reload(),
      },
    })
  )
}

export const handleOpenSuccessDialog = (classUuid) => (dispatch) => {
  dispatch(
    openDialog({
      isCloseDialog: false,
      iconType: 'time',
      title: 'รอผลการตรวจสอบ',
      message: [
        'ระบบได้ทำการส่งอีเมลยืนยันการลงทะเบียนให้คุณเรียบร้อยแล้ว',
        'โปรดตรวจสอบรายละเอียดทางอีเมลอีกครั้ง',
      ],
      buttonRight: {
        label: 'ไปที่คลาสเรียน',
        endIcon: <ArrowForward />,
        handleClick: () =>
          (window.location.href = `/e-learning/course/${classUuid}`),
      },
      buttonLeft: {
        label: 'ดูหลักสูตรอื่นต่อ',
        handleClick: () => (window.location.href = '/e-learning/course'),
      },
    })
  )
}

export const handleGetInClass = (history) => async (dispatch) => {
  const data = getDetailState().data
  const courseType = _.get(data, 'courseType', '')

  if (courseType === COURSE_TYPE.OIC) {
    dispatch(setChangeCamera({ key: 'isOpen', value: false }))
    dispatch(openDetailDialog())
  } else {
    const eLearningCourse = handleRelationObj(data)
    const payload = { eLearningCourse, eLearningCourseBatch: null }
    dispatch(startLoading())
    const response = await dispatch(postCourseLogLearner(payload))
    dispatch(stopLoading())

    if (_.isEmpty(response.error)) {
      const uuid = _.get(eLearningCourse, 'uuid', '')
      history.push(`/e-learning/course/learning/${uuid}`)
    }
  }
}
